const RequestCsiNote = async (input, filtermessages, userId, mode, loginInfo, setMessages) => {
//ApiHandler.search              (newMessage.text, filterMessages, 'test_user', mode, loginInfo,setMessages)

    //const filter = loginInfo.faqapi.csinote.filter
    const filter =["(group eq 'ServicePortal' ) and (category eq 'action')",
"(status eq 'publish') and (search.in(type, '008,026,036,041,042,043,044,049,050,061,070,074,078,086,087,089,096,097,098,107,115,117,118,133,134,138,144,146,156', ',') or search.in(tag, 'customer', ',') or (category eq 'wave'))",
"((status eq 'publish') or (status eq null)) and (search.in(bu,'44K544Kx44O844Or44Oh44OH44Kj44Ki5LqL5qWt6YOo,44OH44K444K444Oj44OR44Oz,44OV44O844OJ5LqL5qWt6YOo,44Ob44K544OU5LqL5qWt6YOo,44Oq44OG44Kk44Or5LqL5qWt6YOo,44Ot44K444K544OG44Kj44OD44Kv44K544K944Oq44Ol44O844K344On44Oz,5YyF6KOF5LqL5qWt6YOo,55Kw5aKD5LqL5qWt6YOo', ',') or search.in(filter3, 'customer', ','))",
"(status eq 'publish') and (category eq 'CSINote') and (user eq '531038439' or sub_category eq '123000000' or group eq '14154373')", 
"(status eq 'publish') and (filter5 eq 'CSINote') and (filter4 eq '531038439' or filter3 eq '537004225' or filter2 eq '14154373')"]

    //const filter = "(category eq 'RAG-TRK-S')"     
    //const filter = "(category eq 'action')or(category eq 'RAG-TRK-S')"
    //(group eq 'ServicePortal' ) and (category eq 'action')or (category eq 'RAG-TRK-S')
    let prompt
    

    prompt=`あなたは「FAQ」「取扱説明書」「注意事項」の情報を参照して「質問」の要望に答えるRAGアシスタントです。
# ルール
-1. 回答に使用できる情報は「取扱説明書」「FAQ」からも簡潔に箇条書きにして
-2. 必要な情報、通常知識にも存在しない場合、**「×」のみ返す**
-3. 重要な設定値は省略しない。
-4. 画像の情報が重要です。URLの画像や動画のリンクがあります。画像や動画を必ず表示させてください。
-5. 質問に対して関連する【注意事項】の中から関連するルールや注意点や手順を抽出し、わかりやすく提示してください。
-6.【質問の回答】も必ず参考にした情報はファイル名orサイトのURLのリンクをつけてください
# 出力フォーマット 
-【質問の回答】(質問の要望に応える)【注意事項】(～はしてはダメです。)`

//「注意事項」は、ルール、注意点、手順が記載されています。
//   prompt=`あなたは注意事項・ルールの専門アドバイザーです。
//## タスク
//ユーザーの【質問】に対して、【注意事項】の中から関連するルールや注意点や手順を抽出し、わかりやすく提示してください。
//## 出力ルール
//- 関連する注意事項を選んでください
//- 関連する手順は、タイトルとリンクをつけてください。詳細手順は不要
//- 各項目を箇条書きで提示してください
//- 必ず参考にした情報はファイル名orサイトのURLのリンクをつけてください
//- 該当する注意事項がない場合は「該当する注意事項はありません」と回答してください`

//直近のメッセージボットの1つ取得
    filtermessages.shift();
    const histmessages = filtermessages.slice(-1);

    const repInput = histmessages
    .filter(msg => msg.sender === "user") // userのメッセージだけに絞る
    .map((msg, index) => {
        // テキストからHTMLタグを除去
        const cleanText = msg.text.replace(/<[^>]*>|\[画像情報\]/g, '');
        // filename がある場合は filename + text を結合
        const combinedText = msg.imagemessage
        ? `${msg.imagemessage} ${cleanText}`
        : cleanText;
        const numberedText = `${combinedText}`;

        return { content: numberedText };
    });

    const query = {
        search: repInput[0].content,
        top: 5,
        filter: '',
        select: "sub_category,category,title,content,answer,text,site_name,URL,site_icon,model,update_at,tag",
        vectorQueries: [
            { 
                kind: "text",
                text: repInput[0].content,
                k: 5,
                fields: "embedding"
            }
        ],
    queryType: "semantic",
    captions: "extractive",
    answers: "extractive|count-3",
    semanticConfiguration: "cosmosdb03-semantic-configuration",
    queryLanguage: "ja-JP"
    }

    const header = {
        'Content-Type': 'application/json',
        'api-key': "XXXXXXXXX",
    };

    const requestBody = {
        api:process.env.REACT_APP_FAQ_URL,
        header:header,
        query: query,
        filter:filter,
        userId: userId,
        mode:mode,
        prompt:prompt,
        inputs:repInput[0].content
    };

    try {

        const response = await fetch(`${process.env.REACT_APP_CROSPRO_URL}?code=${process.env.REACT_APP_CROSPRO_KEY}`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(requestBody),
        });

        const reader = response.body.getReader();
        const decoder = new TextDecoder("utf-8");
        let buffer = "";
        let resmessage = "";

        while (true) {

            const { done, value } = await reader.read();
            if (done) break;

            buffer += decoder.decode(value, { stream: true });
            const lines = buffer.split("\n");
            buffer = lines.pop();

            for (let line of lines) {
            line = line.trim();
            if (!line.startsWith("data:")) continue;
            const jsonStr = line.replace(/^data:\s*/, "");
            
            if (jsonStr === "[DONE]") continue;

            try {
                const dataObj = JSON.parse(jsonStr);
                const delta = dataObj.choices[0].delta.content;
                resmessage += delta; // ここで逐次 finalText に追加
                if (delta) {
                setMessages((prev) => {
                    const newMessages = [...prev];
                    if (newMessages.length === 0 || newMessages[newMessages.length - 1].sender !== "csinote"
                    ) { 
                        newMessages.push({ id: crypto.randomUUID(),sender: "csinote", text: delta , mode: 'csinote', timestamp: Date.now()});
                    } else {
                        newMessages[newMessages.length - 1].text += delta;
                    }
                    return newMessages;
                });
                }
            } catch (e) {
                console.error("JSON parse error:", e, jsonStr);
            }
            }
        }

        return resmessage

    } catch (error) {
        console.log('API_応答データerror:', error);
        return `申し訳ありません。<br>問合せエラーが発生しました。`
    }

};

// 🔹 他のファイルで使えるようにエクスポート
export default RequestCsiNote;
